import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=1744b67e&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"
import style0 from "./tasks.vue?vue&type=style&index=0&id=1744b67e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744b67e",
  null
  
)

export default component.exports